import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FeatureProfile } from '../shared/feature-profile.model';
import { RegionFeatures } from '../shared/region-features.model';
import { ControlContainer, NgForm } from '@angular/forms';
import { ProofOfDeliveryRule } from '../shared/pod-rule.model';
import { InheritableOnOffFeature, OnOffFeature } from '../shared/on-off-feature.model';
import { RegionFeatureOverrideAbility } from '../shared/region-feature-override-ability.model';
import { FeatureUtils } from '../shared/feature-utils';
import { RegionFeatureStatus } from '../shared/region-feature-status.model';

@Component({
  selector: 'app-feature-profile-editor',
  templateUrl: './feature-profile-editor.component.html',
  styleUrls: ['./feature-profile-editor.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class FeatureProfileEditorComponent implements OnInit, OnChanges {

  @Input()
  featureProfile: FeatureProfile;

  @Input()
  regionFeatures: RegionFeatures;

  @Input()
  form: NgForm;

  @Input()
  showError = false;

  @Output()
  errorMessageKeyEmitter = new EventEmitter<string>();

  driverAssignmentModes = FeatureUtils.DRIVER_ASSIGNMENT_MODE;
  proofOfDeliveryRules  = FeatureUtils.PROOF_OF_DELIVERY_RULES;
  photoPodRules         = FeatureUtils.PHOTO_POD_RULES;
  onOffPossibleValues   = FeatureUtils.INHERITABLE_ON_OFF_POSSIBLE_VALUES;
  autoGroupCollections  = FeatureUtils.AUTO_GROUP_COLLECTION;
  automaticTripCreationOrderTypes = FeatureUtils.AUTOMATIC_TRIP_CREATION_ORDER_TYPES;
  useCmaLiteOverCicoDeliveryRules = FeatureUtils.USE_CMA_LITE_OVER_CICO_DELIVERY_RULE;

  InheritableOnOffFeature      = InheritableOnOffFeature;
  OnOffFeature                 = OnOffFeature;
  RegionFeatureOverrideAbility = RegionFeatureOverrideAbility;
  ProofOfDeliveryRule          = ProofOfDeliveryRule;

  constructor() {
  }

  ngOnInit() {
    this.form.control.setValidators(this.tripCreationConflictValidator.bind(this));
    this.form.control.updateValueAndValidity();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.regionFeatures && changes.regionFeatures.currentValue) {
      this.featureProfile.applyRegionFeatures(this.regionFeatures);
    }
  }

  setAutomaticTripCreationOrderTypes() {
    if (this.featureProfile.automaticTripCreationFeature === InheritableOnOffFeature.INHERITED) {
      this.featureProfile.automaticTripCreationOrderTypes = this.regionFeatures.automaticTripCreationOrderTypes;
    } else if (this.featureProfile.automaticTripCreationFeature === InheritableOnOffFeature.OFF) {
      this.featureProfile.automaticTripCreationOrderTypes = [];
    }
  }

  automaticTripCreationOrderTypesChanged() {
    this.form.form.markAsDirty();
  }

  isAutomaticTripCreationOn(): boolean {
    return this.featureProfile.automaticTripCreationFeature === InheritableOnOffFeature.ON
        || (this.featureProfile.automaticTripCreationFeature === InheritableOnOffFeature.INHERITED && this.regionFeatures.automaticTripCreationValue);
  }

  tripCreationConflictValidator(): {conflict: boolean} {
    if (this.featureProfile.tmsLoadsSynchronization && this.isAutomaticTripCreationOn()) {
      this.errorMessageKeyEmitter.emit('feature-profiles.trip-gen-and-trip-creation-not-allowed')
      return { conflict: true };
    }
    this.errorMessageKeyEmitter.emit(null);
    return null;
  }

  forceDirtyFormForDynamicallyDisableField() {
    setTimeout(() => this.form.control.markAsDirty(), 100 );
  }
}
